import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { POSTS } from "@/data/posts";
import CTABand from "@/components/CTABand";
import { useSeo } from "@/lib/seo";
import { useReveal } from "@/lib/reveal";

const fmt = (iso) => new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });

export default function Resources() {
  useSeo({
    title: "Resources · Field notes for rental operators",
    description: "Operator-written field notes on running a modern rental business — marine, equipment, recreation and beyond.",
    path: "/resources",
  });
  useReveal();

  return (
    <>
      <section className="ra-mesh">
        <div className="ra-container py-20 sm:py-28">
          <div className="max-w-3xl">
            <span className="ra-pill"><span className="h-1.5 w-1.5 rounded-full bg-ra-amber" /> Field notes</span>
            <h1 className="mt-5 ra-h1">Operator-written, not vendor-written.</h1>
            <p className="mt-5 ra-lead">
              The things we wish someone had told us before we bought our first booking platform — and the things we've learned shipping RentAnything against real fleets.
            </p>
          </div>
        </div>
      </section>

      <section className="pb-20 sm:pb-28">
        <div className="ra-container">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {POSTS.map((p) => (
              <Link
                key={p.slug}
                to={`/resources/${p.slug}`}
                className="group relative overflow-hidden rounded-3xl border border-ra-line bg-white shadow-card transition-all hover:-translate-y-1 hover:shadow-soft reveal"
                data-testid={`post-card-${p.slug}`}
              >
                <div className={`relative aspect-[16/10] bg-gradient-to-br ${p.accent}`}>
                  <div className="absolute inset-0 ra-grain opacity-40" />
                  <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between text-[11px] font-semibold uppercase tracking-wider text-ra-ink/60">
                    <span>{fmt(p.date)}</span>
                    <span className="inline-flex items-center gap-1"><Clock size={11} /> {p.readMins} min</span>
                  </div>
                </div>
                <div className="p-6">
                  <h2 className="font-display text-lg font-semibold leading-snug text-ra-ink group-hover:text-ra-ocean transition-colors">{p.title}</h2>
                  <p className="mt-3 text-sm text-ra-ink/70 leading-relaxed">{p.excerpt}</p>
                  <span className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-ra-ocean">
                    Read more <ArrowRight size={14} className="transition-transform group-hover:translate-x-0.5" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <CTABand
        eyebrow="Want this in your inbox?"
        title="Subscribe to the field notes."
        sub="One short note a month. Operator-grade only — no fluff."
        primaryLabel="Talk to us"
      />
    </>
  );
}
